import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getShiftTypeCompany,
  updateShiftTypeCompany,
} from "../../actions/shiftTypeCompanyActions";
import { Grid, TextField } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import Form from "./Form";

class UpdateShiftTypeCompanyForm extends Component {
  state = {
    shiftTypeName: "",
    companyName: "",
    price: "",
  };

  componentDidMount() {
    this.props
      .getShiftTypeCompany(this.props.shiftTypeId, this.props.companyEmail)
      .then((shiftTypeCompany) => {
        this.setState({
          shiftTypeName: shiftTypeCompany.name,
          companyName: shiftTypeCompany.companies[0].name,
          price: shiftTypeCompany.companies[0].ShiftTypeCompany.price,
        });
      });
  }

  updateShiftTypeCompany = (e) => {
    e.preventDefault();
    this.props
      .updateShiftTypeCompany(
        this.props.shiftTypeId,
        this.props.companyEmail,
        this.state,
      )
      .then(
        () =>
          (window.location.href = `/shifttype/${this.props.shiftTypeId}/update`),
      );
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleCheckboxChange = (e) =>
    this.setState({ [e.target.name]: e.target.checked });

  handlePriceChange = (e) =>
    this.setState({ [e.target.name]: parseFloat(e.target.value).toFixed(2) });

  render() {
    return (
      <Form
        onSubmit={this.updateShiftTypeCompany}
        submitText="Wijzigen"
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              id="shiftTypeName"
              name="shiftTypeName"
              label="Dienstsoort *"
              value={this.state.shiftTypeName}
              disabled
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="companyName"
              name="companyName"
              label="Bedrijfsnaam *"
              value={this.state.companyName}
              disabled
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="price"
              name="price"
              type="number"
              label="Uurtarief *"
              value={this.state.price}
              onChange={this.handleChange}
              onBlur={this.handlePriceChange}
              fullWidth
              InputProps={{
                min: ".01",
                step: ".01",
                startAdornment: (
                  <InputAdornment position="start">€</InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Form>
    );
  }
}

UpdateShiftTypeCompanyForm.propTypes = {
  shiftTypeId: PropTypes.string.isRequired,
  companyEmail: PropTypes.string.isRequired,
  getShiftTypeCompany: PropTypes.func.isRequired,
  updateShiftTypeCompany: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.shiftTypeCompany.updateShiftTypeCompany.successMessage,
  errorMessage: state.shiftTypeCompany.updateShiftTypeCompany.errorMessage,
  isFetching:
    state.shiftTypeCompany.getShiftTypeCompany.isFetching ||
    state.shiftTypeCompany.updateShiftTypeCompany.isFetching,
});

export default connect(mapStateToProps, {
  getShiftTypeCompany,
  updateShiftTypeCompany,
})(UpdateShiftTypeCompanyForm);



// WEBPACK FOOTER //
// ./src/components/forms/UpdateShiftTypeCompanyForm.js